import React from 'react';
import cx from 'classnames';
import SilentVideo from '@src/components/silent-video';
import wrapStore from '@src/utils/wrap-store';
import store from './store';

const styles = require('./index.less');

export default wrapStore(function KvVideo({ store, src, cover }) {
  store.use();

  return (
    <div className={cx(styles.kvRoot, { [styles.showCover]: store.isShowCover })}>
      <div className={styles.cover} style={{ backgroundImage: `url(${cover})` }} />
      <SilentVideo ref={store.ref} loop={false} autoPlay={false} cover={cover} src={src} className={styles.kvVideo} callback={store.onCanPlayThrough} />
    </div>
  );
}, store);
